import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  BUTTON: '[data-fragment="BackToTopComponent.button"]',
};

class BackToTopComponent extends WebComponent {
  constructor(props) {
    super(props);
    const {
      show = false,
      offsetFromTop = 500,
    } = props;
    this.state = {
      show,
      offsetFromTop,
    };
  }

  didMount() {
    window.addEventListener('scroll', this.initButton);
    this.buttonElement = this.element.querySelector(fragments.BUTTON);
    this.on('click', fragments.BUTTON, this.handleClickButton);
  }

  initButton = (e) => {
    const {
      show,
      offsetFromTop,
    } = this.state;

    if (document.body.scrollTop > offsetFromTop || document.documentElement.scrollTop > offsetFromTop) {
      this.setState({
        show: true,
      });
    } else {
      this.setState({
        show: false,
      });
    }
  }

  handleClickButton = (e) => {
    const {
      show,
    } = this.state;

    this.setState({
      show: !show,
    });
    const scrollToTop = () => {
      const c = document.documentElement.scrollTop || document.body.scrollTop;
      if (c > 0) {
        window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, c - c / 12);
      }
    };
    scrollToTop();
  }

  willUnMount() {
    this.buttonElement = null;
  }

  update(prevProps, prevState, inDocument) {
    const {
      show,
    } = this.state;

    classNames(this.element, {
      'back-to-top--show': show,
    });
  }
}

export default BackToTopComponent;




// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/BackToTopComponent/BackToTopComponent.js